import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useTranslation } from "react-i18next";
import { Quote } from "lucide-react";

const stories = [
    {
        portrait: "/images/portrait-3.jpg",
        nameKey: "homepage.stories.s1.name",
        roleKey: "homepage.stories.s1.role",
        quoteKey: "homepage.stories.s1.quote",
    },
    {
        portrait: "/images/portrait-2.jpg",
        nameKey: "homepage.stories.s2.name",
        roleKey: "homepage.stories.s2.role",
        quoteKey: "homepage.stories.s2.quote",
    },
    {
        portrait: "/images/portrait-1.jpg",
        nameKey: "homepage.stories.s3.name",
        roleKey: "homepage.stories.s3.role",
        quoteKey: "homepage.stories.s3.quote",
    },
];

const StoriesSection = () => {
    const { t } = useTranslation();
    const { ref, isVisible } = useScrollAnimation();

    return (
        <section
            ref={ref}
            className={`py-24 bg-muted transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
        >
            <div className="max-w-7xl mx-auto px-6">
                <div className="text-center mb-16 max-w-2xl mx-auto">
                    <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
                        {t('homepage.stories.eyebrow')}
                    </span>
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight">
                        {t('homepage.stories.title')}
                    </h2>
                    <p className="text-lg text-muted-foreground">
                        {t('homepage.stories.subtitle')}
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {stories.map((story, index) => (
                        <article
                            key={index}
                            className={`bg-card rounded-3xl p-8 border border-border shadow-sm hover:shadow-md transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                                }`}
                            style={{ transitionDelay: `${index * 150}ms` }}
                        >
                            <Quote className="w-8 h-8 text-primary/40 mb-4" />
                            <p className="text-foreground leading-relaxed mb-8">
                                "{t(story.quoteKey)}"
                            </p>
                            <div className="flex items-center gap-4 pt-6 border-t border-border">
                                <img
                                    src={story.portrait}
                                    alt={t(story.nameKey)}
                                    className="w-14 h-14 rounded-full object-cover"
                                    loading="lazy"
                                />
                                <div>
                                    <p className="font-semibold text-foreground">{t(story.nameKey)}</p>
                                    <p className="text-sm text-muted-foreground">{t(story.roleKey)}</p>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StoriesSection;
